import React from 'react';
import {connect} from 'react-redux';
import cn from 'classnames';
import styles from './index.module.css';
import {splitChargeCard, addPrices, formatPrice} from '../utils';
import LineItemHeader from '../LineItemHeader';
import tag from './tag.svg';

import {getPurchase, getGroupedLineItems} from 'reducers';

import {LONG_DATE_FORMAT, SHORT_DATE_FORMAT} from 'app_constants';
import {formatDate} from 'helpers/formatters';
import Box from 'common/Box';
import CardIcon from 'billing/CardIcon';


export const Purchase = ({id, purchase, groupedLineItems}) => {
  if (!purchase || !id) {
    return null;
  }

  const [cardType, lastFour] = splitChargeCard(purchase.charge_card)

  return (<div className="Purchase">
      <Box>
        <div className={styles.header}>
          <span>
            {purchase.purchase_date ? formatDate(purchase.purchase_date, LONG_DATE_FORMAT) : 'Pending'}
          </span>
          <span>
            #{purchase.id}
          </span>
          <span>
            <span className={styles.cardIcon}>
              <CardIcon cardType={cardType} color="light"/>
            </span>
            {' '}
            {lastFour}
          </span>
          <span className={styles.headerPrice}>
            ${purchase.cost.total}
          </span>
        </div>

        <div className={styles.lineItems}>
          <div className={styles.lineItemsHeader}>
            <span>
              Item
            </span>
            <span>
              Item Price
            </span>
          </div>
          {groupedLineItems && groupedLineItems.map((group, i) => <div
            key={`${group.bypassedSubscription} ${group.sprintSubscription}`}>
            {group.other && i > 0 && <div className={styles.otherRule}/>}
            {group.other && <div className={styles.otherHeader}/>}
            <LineItemHeader
              quickSubId={group.quickSubscription}
              bypassedSubId={group.bypassedSubscription}
              sprintSubId={group.sprintSubscription}
            />
            {group.lineItems.map(item => <div className={styles.lineItem} key={item.id}>
              <div className={styles.itemContent}>
                <div className={styles.itemTitle}>
                  {item.title}
                  {item.from_date && <span className={styles.itemDates}>
                          {formatDate(item.from_date, SHORT_DATE_FORMAT)}
                    {' - '}
                    {formatDate(item.to_date, SHORT_DATE_FORMAT)}
                        </span>}
                </div>
                <div className={styles.itemDesc}>
                  {item.description}
                </div>
              </div>
              <div className={styles.itemPrice}>
                {formatPrice(item.price)}
              </div>
            </div>)}
          </div>)}

          <div className={styles.lineItemsFooter}>
            <span className={styles.itemSubTitle}>
              <img className={styles.taxesTag} src={tag} alt=""/>
              Fees
            </span>
            <span>
              {/*{formatPrice(addPrices([purchase.cost.economic_adjustment_fees, purchase.cost.admin_fees]))}*/}
            </span>
          </div>
          {!!+purchase.cost.economic_adjustment_fees && <div className={cn(styles.subLineItemsFooter, styles.subLineItemsFeeDetails)}>
              <span className={styles.subLineItemsLabel} >
                Economic Adjustment Fee
              </span>
            <span>
                {formatPrice(addPrices([purchase.cost.economic_adjustment_fees]))}
              </span>
          </div>}
          <div className={cn(styles.subLineItemsFooter, styles.subLineItemsFeeDetails)}>
              <span className={styles.subLineItemsLabel} >
                Admin Fee
              </span>
            <span>
                {formatPrice(addPrices([purchase.cost.admin_fees]))}
              </span>
          </div>


          <div className={styles.lineItemsFooter}>
            <span className={styles.itemSubTitle}>
              <img className={styles.taxesTag} src={tag} alt=""/>
              Taxes
            </span>
            <span>
              {formatPrice(addPrices([purchase.cost.taxes]))}
            </span>
          </div>
        </div>

        <div className={styles.footer}>
          <span>
            TOTAL
          </span>
          <span className={styles.footerPrice}>
            {formatPrice(purchase.cost.total)}
          </span>
        </div>
      </Box>
    </div>)
}

const mapStateToProps = (state, {id}) => ({
  purchase: getPurchase(state, id), groupedLineItems: getGroupedLineItems(state, id),
});

export default connect(mapStateToProps)(Purchase);
